// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'IOVF', 'IOVF Fallback'"},"className":"__className_73ba36","variable":"__variable_73ba36"};